<template>
    <div class="side-nav primary"  v-resize="onResize">
        <div class="navbar-brand">
            <a class="white primary--text">LIFTMANAGER</a>
        </div>

        <div class="ml-5 mt-1 mb-1">
            <div>
                <a @click="onLiftmanagement">
                    <v-icon color="white" size="20">mdi-elevator-passenger</v-icon>
                    <span class="ml-1">Liftmanagement</span>
                </a>
            </div>

            <div v-if="isDispatcher || isRestrictedDispatcher || isDisponent"  class="mt-n1">
                <a @click="onDisposition">
                    <v-icon color="white" size="20">mdi-folder-clock-outline</v-icon>
                    <span class="ml-1">Disposition</span>
                </a>
            </div>

            <div  class="mt-n1">
                <a @click="onInbox">
                    <v-icon color="white" size="20">mdi-inbox</v-icon>
                    <span class="ml-1">Inbox</span>
                </a>
            </div>
            <div class="mt-n1">
                <a @click="onOutbox">
                    <v-icon color="white" size="20">mdi-inbox-arrow-up</v-icon>
                    <span class="ml-1">Outbox</span>
                </a>
            </div>

            <div class="mt-n1">
                <a @click="onSites">
                    <v-icon color="white" size="20">mdi-elevator</v-icon>
                    <span class="ml-1">Anlagen</span>
                </a>
            </div>
            <div  class="mt-n1">
                <a @click="onPreferences">
                    <v-icon color="white" size="20">mdi-wrench-outline</v-icon>
                    <span class="ml-1">Einstellungen</span>
                </a>
            </div>
        </div>

        <v-divider class="white mt-1"></v-divider>
        <div style="overflow-y: scroll" :style="'max-height: ' + height + 'px'">
            <div class="ml-5 mt-1 mb-1">
                <div class="sub-title">
                    Unternehmen
                </div>
            </div>
            <v-divider class="white mb-1"></v-divider>

            <div class="ml-5 mt-0 mb-0">
                <div>
                    <a @click="onCustomer">
                        <v-icon color="white" size="20">mdi-account-group</v-icon>
                        <span class="ml-1">Kunden</span>
                    </a>
                </div>

                <div class="mt-n1">
                    <a @click="onService">
                        <v-icon color="white" size="20">mdi-cogs</v-icon>
                        <span class="ml-1">Service</span>
                    </a>
                </div>

                <div  class="mt-n1">
                    <a @click="onInspection">
                        <v-icon color="white" size="20">mdi-clipboard-outline</v-icon>
                        <span class="ml-1">ZÜS</span>
                    </a>
                </div>
            </div>

            <v-divider class="white mt-0 mt-2"></v-divider>
            <div class="ml-5 mt-1 mb-1">
                <div class="sub-title">
                    Reports
                </div>
            </div>
            <v-divider class="white mb-1"></v-divider>

            <v-expansion-panels accordion flat  class="primary white--text">
                <v-expansion-panel class="primary white--text">
                    <v-expansion-panel-header style="color: white; padding-right: 10px;">
                        <v-icon color="white" size="20">mdi-microsoft-excel</v-icon>
                        <span>Excel</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div>
                            <report-list area="reports" :show="show" :format="1"/>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="primary white--text">
                    <v-expansion-panel-header style="color: white; padding-right: 10px;">
                        <v-icon color="white" size="20">mdi-file-pdf-box</v-icon>
                        <span>PDF</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div>
                            <report-list area="reports" :show="show" :format="2"/>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>

            <v-divider class="white mt-1" v-if="isDataAdmin"></v-divider>
            <div class="ml-5 mt-1 mb-1" v-if="isDataAdmin">
                <div class="sub-title">
                    Stammdaten
                </div>
            </div>
            <v-divider class="white mb-1" v-if="isDataAdmin"></v-divider>
            <v-expansion-panels accordion flat  class="primary white--text" v-if="isDataAdmin">
                <v-expansion-panel class="primary white--text">
                    <v-expansion-panel-header style="color: white; padding-right: 10px;">
                        <v-icon color="white" size="20">mdi-database-export</v-icon>
                        <span>Export</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div>
                            <report-list area="Export" :show="show" :format="1"/>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="primary white--text">
                    <v-expansion-panel-header style="color: white; padding-right: 10px;">
                        <v-icon color="white" size="20">mdi-database-import</v-icon>
                        <span>Import</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div>
                            <c-importer-list class="mb-3" />
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>

            <v-divider class="white mt-1"></v-divider>
            <div class="ml-5 mt-1 mb-1">
                <div class="sub-title">
                    Dokumente
                </div>
            </div>
            <v-divider class="white"></v-divider>
            <div class="ml-5 mt-1 mb-1">

                <div>
                    <a @click="onDocExport">
                        <v-icon color="white" size="20">mdi-export</v-icon>
                        <span class="ml-1">Export</span>
                    </a>
                </div>
                <div class="mt-n1">
                    <a @click="onDocuments" >
                        <v-icon color="white" size="20">mdi-book-open-outline</v-icon>
                        <span class="ml-1 mt-1">Browser</span>
                    </a>
                </div>
            </div>
            <v-divider class="white mt-0"></v-divider>
        </div>
        <div class="app-version">Liftmanager v{{ appVersion }}</div>
    </div>
</template>

<script>

import ReportList from "@/modules/rep/components/ReportList";
import Core from "@/modules/core/service/Core";
import CImporterList from "@/modules/msd/importer/components/CImporterList.vue";

export default {
    name: "CAppSideDrawer",
    components: {
        CImporterList,
        ReportList
    },

    props: {
        show: {

        }
    },

    data: () => ({
        group: null,
        height: null,
        appVersion: __APP_VERSION__
    }),

    computed: {
        isDataAdmin () {
            return Core.security.isDataAdmin();
        },

        privileged () {
            return Core.security.isPrivileged();
        },

        isDispatcher () {
            return Core.security.isDispatcher();
        },

        isRestrictedDispatcher () {
            return Core.security.isRestrictedDispatcher();
        },

        isDisponent () {
            return Core.security.isDisponent();
        },
    },

    mounted() {
        this.onResize();
    },

    methods: {
        onLiftmanagement () {
            Core.nav.push(this, "home");
        },

        onInbox () {
            Core.nav.push(this, "imports");
        },

        onOutbox () {
            Core.nav.push(this, "outbox");
        },

        onCustomer () {
            Core.nav.push(this, "customer");
        },

        onSites () {
            Core.nav.push(this, "sites");
        },

        onService () {
            Core.nav.push(this, "service");
        },

        onInspection () {
            Core.nav.push(this, "zues");
        },

        onPreferences () {
            Core.nav.push(this, "preferences");
        },

        onDocuments () {
            Core.nav.push(this, "documents");
        },

        onDocExport () {
            Core.nav.push(this, "docexport");
        },

        onDisposition () {
            Core.nav.push(this, "disposition");
        },

        onResize () {
            this.height = window.innerHeight- 240;
        }
    }
}
</script>

<style scoped>

::v-deep .v-expansion-panel-header {
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 20px;
    min-height: 35px;
}

::v-deep .v-expansion-panel--active>.v-expansion-panel-header {
    min-height: 35px;
}

::v-deep .v-expansion-panel-header i {
    margin-right: 10px;
    max-width: 15px;
}

::v-deep .v-expansion-panel-header__icon i {
    font-size: 9pt;
    color: white!important;
    flex: unset;
}

::v-deep .v-expansion-panel-content__wrap {
    padding-bottom: 0;
    padding-left: 30px;
    padding-right: 10px;
}

::v-deep .v-list-item {
    min-height: 35px;
}

::v-deep .v-list {
    padding-top: 0;
    padding-bottom: 0;
}

.side-nav {
    height: 100%;
}

.side-nav a {
    height: 36px;
    font-weight: 400;
    line-height: 36px;
    color: #fff;
}

.navbar-brand a {
    display: block;
    height: 47px;
    padding-left: 0;
    padding-top: 7px;
    font-size: 1rem!important;
    line-height: 40px;
    text-decoration: none;
    font-weight: 900!important;
    text-align: center;
}

.side-nav ul {
    padding-left: 0;
    list-style: none;
}

.side-nav ul li {
    padding: 0;
}

::v-deep .v-expansion-panel-header,
::v-deep .v-expansion-panel-header__icon,
.side-nav a {
    font-size: 10pt;
}

::v-deep .v-expansion-panels--popout>.v-expansion-panel {
    max-width: 100%
}

::v-deep .theme--light.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header--active:hover::before, .theme--light.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header--active::before {
    opacity: 0.2;
}

.sub-title {
    color: white;
    font-size: 15px;
}


.import-list-item {
    font-size: 14px;
    font-weight: 400;
    padding-left: 11px;
    min-height: 30px;
    padding-top: 8px!important;
    padding-bottom: 0!important;
}

div::-webkit-scrollbar {
    width: 0 !important;
}

.app-version {
    color: white;
    font-size: 12px;
    margin-left: 15px;
    margin-top: 10px;
    margin-bottom: 10px;
}

</style>